import { objectType } from 'types';
import { BaseXHR } from 'utils/axios';

/** Báo cáo doanh thu theo nhóm (type=parkId: theo công viên). month=0 là cả năm */
export const getDashboardRevenueApi = (
  params?: objectType,
  config?: objectType,
) => BaseXHR.$get('b2b/v1/dashboard/revenue', params, config);

/** Báo cáo top doanh thu (type=show: sản phẩm, type=agent: nhân viên bán hàng) */
export const getDashboardTopRevenueApi = (
  params?: objectType,
  config?: objectType,
) => BaseXHR.$get('b2b/v1/dashboard/top-revenue', params, config);

export const getOverviewApi = data =>
  BaseXHR.$post('b2b/holiday/dashboard?type=ticketorderwait', data);
export const getStatisticsApi = data =>
  BaseXHR.$post('b2b/holiday/dashboard?type=balanceinfo', data);
export const getRevenueReportApi = data =>
  BaseXHR.$post('b2b/holiday/dashboard?chart=revenueReport', data);
